import Link from "next/link";
import { useMemo } from "react";
import "react-circular-progressbar/dist/styles.css";
import { BiCalendarWeek } from "react-icons/bi";
import { BsThreeDots } from "react-icons/bs";
import { Pack } from "../../firebase/firestore";
import useAuth from "../../hooks/useAuth";
import { useScreenSize } from "../../styles/media-queries";
import { prettyDate } from "../../utils/dates";
import Actions from "../misc/Actions";
import { Selectable } from "../track/TrackRowCompact";
import { composePublicLink } from "./PackPage";

type PackRowProps = {
  pack: Pack;
  ownerNickname?: string;
  hideCreator?: boolean;
  onDelete: () => Promise<any>;
  className?: string;
} & Selectable;

export function PackRow({
  pack,
  ownerNickname,
  className,
  onSelect,
  selected,
  selectable,
  hideCreator,
  onDeselect,
  onDelete,
  ...rest
}: PackRowProps) {
  const actions = useMemo(
    () => [
      {
        cb: onDelete,
        title: "Delete",
      },
    ],
    []
  );

  const { user } = useAuth();

  const weekliesLink = useMemo(
    () => (pack.creator.isCollective ? `/collective/${pack.creator.id}/weeklies` : "/weeklies"),
    [pack]
  );

  const packLink = useMemo(() => {
    if (pack.next_weekly && (!pack.creator?.isCollective || pack.creator?.admins?.includes(user?.uid))) {
      // personal next weekly, or collective netxt weekly being looked by non-admin
      return weekliesLink;
    } else {
      return pack?.publicLink
        ? composePublicLink(pack.creator, pack.publicLink, true)
        : `/@${pack.creator.nickname}/${pack.private_link.value}`;
    }
  }, [pack, user]);

  // direct next weekly pack to /weekly page for admins or personal users

  return (
    <div className={className + " relative group"} {...rest}>
      <div className={` absolute right-full md:right-full z-20 top-0 h-full flex items-center`}>
        {selectable && (
          <input
            type="checkbox"
            onChange={(e) => (selected ? onDeselect() : onSelect())}
            checked={selected || false}
            className={`group-hover:opacity-100 shrink-0 ${"w-5 h-5"} transition-opacity z-10 mr-5 ${
              selected ? "opacity-100" : "opacity-0"
            }`}
          />
        )}
      </div>
      <Link href={packLink}>
        <div className="cursor-pointer  h-14 w-full relative transition rounded  flex items-center justify-between ">
          <div className="flex items-center">
            <div className={`${pack.title ? "inline text-white" : "text-light-gray"} leading-4`}>
              {pack.title || "Untitled"}
            </div>
            {pack.weekly && (
              <div className="flex items-center">
                <BiCalendarWeek className="mx-2" />
                {pack.next_weekly && <div className="text-xs text-gray-400"> (next weekly)</div>}
              </div>
            )}
            {
              <div className="inline ml-2 opacity-70 text-xs text-light-gray">
                {!hideCreator && <span>by @{pack.creator.nickname}</span>}
              </div>
            }
          </div>

          <div className=" text-light-gray relative flex items-center text-sm">
            {/* @ts-ignore */}
            {prettyDate(pack.date_created.toDate ? pack.date_created?.toDate() : pack.date_created)}
          </div>
          <Actions actions={actions} className=" absolute left-full pl-2 opacity-0 group-hover:opacity-100" />
        </div>
      </Link>
    </div>
  );
}
